module.exports = __webpack_public_path__ + "static/13cf5127.downloadimg.png";